import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { CustomService } from '@/shared/services/custom.service';
import { Pessoa } from '@/shared/models/pessoa-info.model';
import {
    AnotacaoInscricaoRequest,
    AnotacaoDocumentosRequest,
    AnotacaoEleicoesRequest,
    AnotacaoPortalRequest,
    AnotacaoRequest,
    AnotacaoRgmRequest,
    AnotacaoVistoProvisorioRequest,
    MedicoAnotacaoInsertRequest
} from '@/core/api/sicom-api/registro/medico/anotacao/anotacao.model';
import { AnotacaoService } from '@/core/api/sicom-api/registro/medico/anotacao/anotacao.service';
import { Page } from '@/shared/models/page.model';

@Injectable({ providedIn: 'root' })
export class AnotacoesFeatureService extends CustomService {
    constructor(private anotacaoCore: AnotacaoService) {
        super();
    }

    buscar(params: Pessoa, page: number, size: number, direction: 'ASC' | 'DESC' = 'DESC'): Observable<Page<AnotacaoRequest>> {
        return this.anotacaoCore.buscar(params, { page, size, direction }).pipe(catchError(this.handleError));
    }

    buscarVistoProvisorio(params: Pessoa, page: number, size: number, direction: 'ASC' | 'DESC' = 'DESC'): Observable<Page<AnotacaoVistoProvisorioRequest>> {
        return this.anotacaoCore.buscarVistoProvisorio(params, { page, size, direction }).pipe(catchError(this.handleError));
    }

    buscarRgm(params: Pessoa, page: number, size: number, direction: 'ASC' | 'DESC' = 'DESC'): Observable<Page<AnotacaoRgmRequest>> {
        return this.anotacaoCore.buscarRgm(params, { page, size, direction }).pipe(catchError(this.handleError));
    }

    buscarPortal(params: Pessoa, page: number, size: number, direction: 'ASC' | 'DESC' = 'DESC'): Observable<Page<AnotacaoPortalRequest>> {
        return this.anotacaoCore.buscarPortal(params, { page, size, direction }).pipe(catchError(this.handleError));
    }

    buscarInscricao(params: Pessoa, page: number, size: number, direction: 'ASC' | 'DESC' = 'DESC'): Observable<Page<AnotacaoInscricaoRequest>> {
        return this.anotacaoCore.buscarInscricao(params, { page, size, direction }).pipe(catchError(this.handleError));
    }

    buscarEleicoes(params: Pessoa, page: number, size: number, direction: 'ASC' | 'DESC' = 'DESC'): Observable<Page<AnotacaoEleicoesRequest>> {
        return this.anotacaoCore.buscarEleicoes(params, { page, size, direction }).pipe(catchError(this.handleError));
    }

    buscarDocumentos(params: Pessoa, page: number, size: number, direction: 'ASC' | 'DESC' = 'DESC'): Observable<Page<AnotacaoDocumentosRequest>> {
        return this.anotacaoCore.buscarDocumentos(params, { page, size, direction }).pipe(catchError(this.handleError));
    }

    inserirAnotacao(pessoa: Pessoa, body: MedicoAnotacaoInsertRequest, context?: HttpContext): Observable<boolean> {
        return this.anotacaoCore.inserirAnotacao(pessoa, body, context).pipe(catchError(this.handleError));
    }

    excluirAnotacao(pessoa: Pessoa, idHistoricoMedico: number): Observable<boolean> {
        return this.anotacaoCore.excluirAnotacao(pessoa, idHistoricoMedico).pipe(catchError(this.handleError));
    }
}
